module.exports = __webpack_public_path__ + "static/media/picture2@2x.191dc592.png";